import ProjectTable from './ProjectTable';
import ProjectDashboardTable from './ProjectDashboardTable';
import ExpensesTable from './ExpensesTable';
import ExpensesTableApplove from './ExpensesTableApplove';
import ExpensesTableProject from './ExpensesTableProject';

export {
  ProjectTable,
  ProjectDashboardTable,
  ExpensesTable,
  ExpensesTableApplove,
  ExpensesTableProject,
};

export default {
  ProjectTable,
  ProjectDashboardTable,
  ExpensesTable,
  ExpensesTableApplove,
  ExpensesTableProject,
};
